import * as React from "react";
const SvgDeprecatedEnumValue = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", fill: "none", viewBox: "0 0 12 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 1.2, d: "m4 8 4-4M4 4l4 4" }), /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.5 1.2H9A1.8 1.8 0 0 1 10.8 3v6A1.8 1.8 0 0 1 9 10.8h-.5V12H9a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3h-.5zm-5 0V0H3a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h.5v-1.2H3A1.8 1.8 0 0 1 1.2 9V3A1.8 1.8 0 0 1 3 1.2z", clipRule: "evenodd" }));
export {
  SvgDeprecatedEnumValue as default
};
//# sourceMappingURL=deprecated-enum-value.js.map
